import React, { useEffect, useState } from 'react';
import Heading from '@legacy-vfuk/core-heading';
import DrawerNavigation from './DrawerNavigation';
import { BrandLogo } from './styles/MainLinks.styles';
import uniqueID from '../../helpers/uniqueId';
import { ReactComponent as VodafoneNoMargin } from '../../images/icon/vodafone-nomargin.svg';
import { runNavigationEventData } from '../../helpers/navigationHelpers';
import { InteractiveIcon } from '@legacy-vfuk/core-interactive-icon';
import {
  MobileBandLogoWrapper,
  MobileNavbar,
} from './styles/MobileNavigation.styles';
import { Link } from './types/Navigation.types';

type MobileNavigationProps = {
  brandLink: string;
  topLevelLinks: Link[];
  mainLinks: Link[];
  pageTitle: string;
  secondLanguageUrlPrefix?: string;
  isSecondLanguageOnUrl?: boolean;
  languageLink: Link;
  signInUrl: string;
  signInLabel: string;
};

const MobileNavigation: React.FC<MobileNavigationProps> = ({
  brandLink,
  topLevelLinks,
  mainLinks,
  languageLink,
  pageTitle,
  secondLanguageUrlPrefix,
  isSecondLanguageOnUrl,
  signInLabel,
  signInUrl,
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  useEffect(() => {
    if (isDrawerOpen) {
      document.body.classList.add('disable-scrolling');
      return;
    }

    document.body.classList.remove('disable-scrolling');
  }, [isDrawerOpen]);

  return (
    <MobileNavbar id="mobile-navbar">
      <ul className="mobile-navbar">
        <li>
          <MobileBandLogoWrapper>
            <BrandLogo
              id="logo"
              href={brandLink}
              aria-label="Vodafone-logo"
              title={'vodafone-icon'}
              data-analytics-element={uniqueID('vodafone-icon')}
              data-analytics-context={pageTitle}
              data-analytics-category={'Link'}
              data-testid={'vodafone-icon'}
              onClick={async () => {
                await runNavigationEventData({ location: 'header' });
              }}
            >
              <VodafoneNoMargin />
            </BrandLogo>
            <Heading size={1} level={1}>
              V-Hub
            </Heading>
          </MobileBandLogoWrapper>
        </li>

        <li>
          <InteractiveIcon
            srText={'open-navigation-drawer'}
            name="menu"
            size={4}
            onClick={() => setIsDrawerOpen(prevState => !prevState)}
          />
        </li>
      </ul>

      <DrawerNavigation
        isOpen={isDrawerOpen}
        setIsOpen={setIsDrawerOpen}
        mainLinks={mainLinks}
        topLevelLinks={topLevelLinks}
        languageLink={languageLink}
        pageTitle={pageTitle}
        secondLanguageUrlPrefix={secondLanguageUrlPrefix}
        isSecondLanguageOnUrl={isSecondLanguageOnUrl}
        signInLabel={signInLabel}
        signInUrl={signInUrl}
      />
    </MobileNavbar>
  );
};

export default MobileNavigation;
